import { Card } from '@eventbrite/eds-card';
import '../../pages/app.scss';

import {
    GRID_TYPE,
    MediaCardContent,
    STANDARD_STYLE,
} from '@eventbrite/eds-media-card-content';
import classNames from 'classnames';
import React from 'react';

const DEFAULT_NUMBER_OF_NEARBY_CITIES = 4;

export type NearbyCity = {
    id: string;
    name: string;
    url: string;
    distance: string;
};

const _formattedName = (name: string) => (
    <span className="eds-text-hs eds-text-weight--light eds-text-color--grey-700">
        {name}
    </span>
);

const _getNearbyPlaceCards = (
    content: NearbyCity[],
    isMobile: boolean,
    isCountry?: boolean,
    handleTrackClick?: Function,
) => {
    const displayManyNearbyCities =
        content.length > DEFAULT_NUMBER_OF_NEARBY_CITIES;

    const classes = displayManyNearbyCities
        ? classNames(
              'eds-l-pad-hor-3 eds-l-pad-vert-2 small-card-mobile small-card-mobile--city',
          )
        : classNames('eds-l-pad-hor-3 eds-l-pad-vert-2', {
              'eds-g-cell eds-g-cell-3-12': !isMobile,
              'small-card-mobile small-card-mobile--city': isMobile,
          });

    return content.map(({ id, name, url, distance }) => (
        <div
            data-testid={`nearby_city_card-${id}_${isMobile}`}
            key={`${id}_${isMobile}`}
            className={classes}
        >
            <Card style="neutral">
                <MediaCardContent
                    shouldShowDivider={true}
                    style={STANDARD_STYLE}
                    type={GRID_TYPE}
                    linkUrl={url}
                    title={_formattedName(name)}
                    subContentOne={isCountry ? '' : distance}
                    onClick={handleTrackClick?.bind(null)}
                    shouldHideImage={true}
                />
            </Card>
        </div>
    ));
};

export const NearbyCities = (props: {
    content: NearbyCity[];
    handleTrackClick: Function;
    isCountry?: boolean;
}) => {
    const { content, handleTrackClick, isCountry } = props;

    return (
        <>
            <div className="mobile-card-carousel eds-show-up-md">
                {_getNearbyPlaceCards(
                    content,
                    false,
                    isCountry,
                    handleTrackClick,
                )}
            </div>
            <div className="mobile-card-carousel eds-show-down-mn">
                {_getNearbyPlaceCards(
                    content,
                    true,
                    isCountry,
                    handleTrackClick,
                )}
            </div>
        </>
    );
};
